import React from 'react'
import Moment from 'react-moment'
import { pascalCase, titleCase } from 'change-case'
import { bgVendorDetailPath } from 'routes'
import { getOptionTitle, numberFormat } from 'core/utilities'
import { IconButton, Tooltip } from '@material-ui/core'
import { Delete, ExpandMore, ExpandLess, Edit } from '@material-ui/icons'
import { StatusTag, DivText, ActionButtonContainer } from './styled'

export const options = {
  listSize: [
    { text: '30', value: 30 },
    { text: '60', value: 60 },
    { text: '90', value: 90 },
    { text: '120', value: 120 }
  ],
  typeOfBond: [
    { text: 'Advance Payment', value: 'advancePayment' },
    { text: 'Performance', value: 'performance' },
    { text: 'Retention', value: 'retention' },
    { text: 'Other', value: 'other' }
  ]
}

export const columns = (vendorOptions, companyOptions) => {
  return [
    {
      Header: 'Status',
      accessor: 'status',
      width: 100,
      Cell: row => (<DivText><StatusTag status={row.value}>{row.original.statusName}</StatusTag></DivText>)
    }, {
      Header: 'Doc No.',
      accessor: 'documentNumber',
      width: 100,
      Cell: row => (<DivText>{row.value}</DivText>)
    }, {
      Header: 'Document Type',
      accessor: 'createType',
      width: 80,
      Cell: row => (<DivText>{pascalCase(row.value)}</DivText>)
    }, {
      Header: () => (<DivText left>Title</DivText>),
      accessor: 'title',
      width: 250
    }, {
      Header: 'Company',
      accessor: 'companyCode',
      width: 100,
      Cell: row => getOptionTitle(companyOptions, row.value)
    }, {
      Header: 'Vendor',
      accessor: 'vendorCode',
      width: 100,
      Cell: row => getOptionTitle(vendorOptions, row.value)
    }, {
      Header: 'Type of Bond',
      accessor: 'typeOfBond',
      width: 100,
      Cell: row => (<DivText>{titleCase(row.value)}</DivText>)
    }, {
      Header: 'Bank Guarantee No.',
      accessor: 'bankGuaranteeNumber',
      width: 100,
    }, {
      Header: 'Amount',
      accessor: 'amount',
      width: 100,
      style: { display: 'flex', justifyContent: 'flex-end' },
      Cell: row => numberFormat(row.value)
    }, {
      Header: 'Due date',
      accessor: 'dueDate',
      width: 120,
      Cell: row => (row.value && <DivText><Moment format='DD MMM YYYY HH:mm'>{row.value}</Moment></DivText>)
    }, {
      Header: 'Created date',
      accessor: 'createdDate',
      width: 120,
      Cell: row => (row.value &&
        <DivText>
          {row.value ? <Moment format='DD MMM YYYY HH:mm'>{row.value}</Moment> : '-'}
        </DivText>)
    }, {
      Header: 'Submitted date',
      accessor: 'submittedDate',
      width: 120,
      Cell: row => (row.value &&
        <DivText>
          {row.value ? <Moment format='DD MMM YYYY HH:mm'>{row.value}</Moment> : '-'}
        </DivText>)
    }, {
      Header: 'Modified date',
      accessor: 'modifiedDate',
      width: 120,
      Cell: row => (row.value && <DivText><Moment format="DD MMM YYYY HH:mm">{row.value}</Moment></DivText>)
    }
  ]
}

export const columnBgRequest = (vendorOptions, companyOptions) => {
  return [
    {
      Header: 'Status',
      accessor: 'status',
      width: 135,
      Cell: row => (<DivText><StatusTag status={row.value}>{row.original.statusName}</StatusTag></DivText>)
    }, {
      Header: 'Doc No.',
      accessor: 'documentNumber',
      width: 100,
      Cell: row => (<DivText>{row.value}</DivText>)
    }, {
      Header: 'Document Type',
      accessor: 'createType',
      width: 80,
      Cell: row => (<DivText>{pascalCase(row.value)}</DivText>)
    }, {
      Header: () => (<DivText left>Title</DivText>),
      accessor: 'title',
      width: 250
    }, {
      Header: 'Company',
      accessor: 'companyCode',
      width: 100,
      Cell: row => getOptionTitle(companyOptions, row.value)
    }, {
      Header: 'Vendor',
      accessor: 'vendorCode',
      width: 100,
      Cell: row => getOptionTitle(vendorOptions, row.value)
    }, {
      Header: 'Type of Bond',
      accessor: 'typeOfBond',
      width: 110,
      Cell: row => (<DivText>{titleCase(row.value)}</DivText>)
    }, {
      Header: 'Amount',
      accessor: 'amount',
      width: 100,
      style: { display: 'flex', justifyContent: 'flex-end' },
      Cell: row => numberFormat(row.value)
    }, {
      Header: 'Created date',
      accessor: 'createdDate',
      width: 120,
      Cell: row => (row.value &&
        <DivText>
          {row.value ? <Moment format='DD MMM YYYY HH:mm'>{row.value}</Moment> : '-'}
        </DivText>)
    }, {
      Header: 'Submitted date',
      accessor: 'submittedDate',
      width: 120,
      Cell: row => (row.value &&
        <DivText>
          {row.value ? <Moment format='DD MMM YYYY HH:mm'>{row.value}</Moment> : '-'}
        </DivText>)
    }, {
      Header: 'Modified date',
      accessor: 'modifiedDate',
      width: 120,
      Cell: row => (row.value && <DivText><Moment format="DD MMM YYYY HH:mm">{row.value}</Moment></DivText>)
    }
  ]
}

export const columnBgRelated = (showAction, onDeleteBgRelated, showExtend) => {
   return [{
    Header: '',
    accessor: 'showExtend',
    width: 50,
    Cell: row => {
      return (
        row.original.haveExtend ? 
          <ActionButtonContainer>
            <IconButton aria-label='Expand' onClick={() => showExtend(row.original.rawIndex) }>
              {row.value ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          </ActionButtonContainer> : null
      )
    }
  }, {
    Header: 'Action',
    accessor: '',
    show: showAction,
    width: 50,
    Cell: row => (
      row.original.documentType === 'original' ?
        <ActionButtonContainer>
          <Tooltip title='Remove'>
            <IconButton onClick={() => onDeleteBgRelated(row.original.bankGuaranteeId)}>
              <Delete />
            </IconButton>
          </Tooltip>
        </ActionButtonContainer> : null
    )
  }, {
    Header: 'Bank Guarantee Number',
    accessor: 'bankGuaranteeNumber',
    width: 200,
    Cell: row => <a href={bgVendorDetailPath(row.original.bankGuaranteeId)} target='_blank'>{row.value}</a>
  }, {
    Header: 'Amount (THB)',
    accessor: 'amount',
    width: 120,
    style: { display: 'flex', justifyContent: 'flex-end' },
    Cell: row => numberFormat(row.value)
  }, {
    Header: 'Bank',
    accessor: 'bankOwner',
  // }, {
  //   Header: 'Status',
  //   accessor: 'statusName',
  //   show: showAction,
  //   style: { display: 'flex', justifyContent: 'center' },
  //   width: 100,
  }, {
    Header: 'Document Type',
    accessor: 'documentType',
    style: { display: 'flex', justifyContent: 'center' },
    width: 110,
    Cell: row => pascalCase(row.value)
  }]
}

export const columnNewBG = (withActions, showModalEditNewBG, onDeleteNewBG) => {
  return ([
    {
      Header: 'Action',
      accessor: '',
      show: withActions,
      width: 100,
      Cell: row => (
        <ActionButtonContainer>
          <Tooltip title='Edit'>
            <IconButton onClick={() => showModalEditNewBG(row.index)}>
              <Edit />
            </IconButton>
          </Tooltip>
          <Tooltip title='Remove'>
            <IconButton onClick={() => onDeleteNewBG(row.index)}>
              <Delete />
            </IconButton>
          </Tooltip>
        </ActionButtonContainer>
      )
    }, {
      Header: 'Bank Guarantee No.',
      accessor: 'bankGuaranteeNumber',
      width: 200,
    }, {
      Header: 'Bank Owner',
      accessor: 'bankOwner',
    }, {
      Header: 'Amount (THB)',
      accessor: 'amount',
      width: 120,
      style: { display: 'flex', justifyContent: 'flex-end' },
      Cell: row => numberFormat(row.value)
    }, {
      Header: 'Start Date',
      accessor: 'startDate',
      width: 120,
      Cell: row => (row.value && <DivText><Moment format='DD MMM YYYY'>{row.value}</Moment></DivText>)
    }, {
      Header: 'Due Date',
      accessor: 'dueDate',
      width: 120,
      Cell: row => (row.value && <DivText><Moment format='DD MMM YYYY'>{row.value}</Moment></DivText>)
    }, {
      Header: 'No Expire',
      accessor: 'noExpire',
      width: 70,
      Cell: row => (row.value ? 'Yes' : 'No')
    }
  ])
}

export const exportColumn = [
  { key: 'statusName', label: 'Status' },
  { key: 'docNo', label: 'Document No.' },
  { key: 'docType', label: 'Document Type' },
  { key: 'title', label: 'Title' },
  { key: 'remark', label: 'BG Remark' },
  { key: 'vendor', label: 'Vendor' },
  { key: 'company', label: 'Company Code' },
  { key: 'typeOfBond', label: 'Type of Bond' },
  { key: 'otherTypeOfBond', label: 'Other Type of Bond' },
  { key: 'amount', label: 'Amount (THB)' },
  { key: 'refChange', label: 'Reference (Change)' },
  { key: 'refExtend', label: 'Reference (Extend)' },
  { key: 'newBg', label: 'New BG' },
  { key: 'bgNumber', label: 'Bank Guarantee No.' },
  { key: 'bankOwner', label: 'Bank Owner' },
  { key: 'startDate', label: 'Start Date' },
  { key: 'dueDate', label: 'Due Date' },
  { key: 'noExpire', label: 'No Expire Date' },
  { key: 'returnedDate', label: 'Return Date' },
  { key: 'job', label: 'Job' },
  { key: 'bgLocation', label: 'Bank Location' },
  { key: 'depositAtBank', label: 'Deposit at BANK' },
  { key: 'depositDate', label: 'Deposit Date' },
  { key: 'depositor', label: 'Depositor' },
  { key: 'depositRemark', label: 'Deposit Remark' },
  { key: 'projectManager', label: 'Project Manager/Head BU' },
  { key: 'creator', label: 'Creator' }
]